<script setup>
import { useSettingsStore } from "@/stores/storeSettings";

const storeSettings = useSettingsStore();
</script>
<template>
	<div class="service-not-product">
        <p>Бронирование этой услуги сейчас недоступно из-за сезонных ограничений.</p>
        <p>Следите за обновлениями клуба в социальных сетях и в нашем приложении — мы обязательно сообщим, когда бронирование откроется с наступлением подходящей погоды.</p>
		<div class="service-not-product__body">
			<a :href="storeSettings.contactsTelegram" target="_blank" rel="noopener noreferrer" class="service-not-product__link">
				<svg width="64" height="64"><use href="#telegram"></use></svg>
			</a>
			<a :href="storeSettings.contactsWhatsapp" target="_blank" rel="noopener noreferrer" class="service-not-product__link">
				<svg width="64" height="64"><use href="#wa"></use></svg>
			</a>
			<a href="https://apps.apple.com/ru/app/the-rink-fitness/id1564341335" target="_blank" rel="noopener noreferrer" class="service-not-product__link --store">
				<svg width="216" height="64"><use href="#appstore"></use></svg>
			</a>
			<a href="https://www.rustore.ru/catalog/app/com.itrack.therinkfitness827436" target="_blank" rel="noopener noreferrer" class="service-not-product__link --store">
				<svg width="216" height="64"><use href="#rustore"></use></svg>
			</a>
		</div>
		<div class="service-not-product__footer">
			<p>Если у вас остались вопросы — свяжитесь с нами.</p>
			<div class="ervice-not-product__list">
				<a :href="`tel:${storeSettings.contactsPhone}`" class="faq__info-link">
                    <svg width="40" height="40"><use href="#phone_border"></use></svg>
                    <span>{{ storeSettings.contactsPhone }}</span>
                </a>
                <a :href="`mailto:${storeSettings.contactsEmail}`" class="faq__info-link">
                    <svg width="40" height="40"><use href="#mail_border"></use></svg>
                    <span>{{ storeSettings.contactsEmail }}</span>
                </a>
			</div>
		</div>
	</div>
</template>
<style lang="scss" scoped>
@use "@/assets/scss/base/vars";
.service-not-product {
	width: 100%;
	max-width: 73rem;
	display: grid;
	gap: 7rem;
    margin: 0 auto;
    @media (max-width: vars.$x480) {
        gap: 3rem;
    }
	p {
		font-weight: 400;
		font-size: 2.8rem;
		line-height: 140%;
		color: var(--text-inverse-100);
        @media (max-width: vars.$x480) {
            font-size: 1.8rem;
        }
	}
}

.service-not-product__body {
    display: flex;
    align-items: center;
    justify-content: start;
    gap: 2.4rem;
    @media (max-width: vars.$x480) {
        flex-wrap: wrap;
        justify-content: center;
    }
}
.service-not-product__link {
    display: flex;
	align-items: center;
	justify-content: center;
	// padding: 1.6rem;
	flex-shrink: 0;
	border: 1px solid transparent;
    &.--store {
        svg {
            width: 21.6rem;
        }
        @media (hover: hover) {
		&:hover {
			border: 1px solid transparent;
			background: transparent;
		}
	}
    }
	svg {
		stroke: transparent;
		stroke-width: 0;
		width: 6.4rem;
		height: 6.4rem;
		transition: var(--transition) ease-in;
	}
	@media (hover: hover) {
		&:hover {
			border: 1px solid var(--border-default-1);
			background: var(--fill-inverse-3);
		}
	}
	&:active {
		border: 1px solid var(--border-default-1);
		background: var(--system-fill-dark);
	}
}
.service-not-product__footer {
}
.ervice-not-product__list {
	margin-top: 4.2rem;
	a {
		display: flex;
        align-items: center;
        gap: 2rem;
        & + .faq__info-link {
            margin-top: 1.6rem;
        }
        @media (hover: hover) {
            &:hover {
                span {
                    border-color: inherit;
                }
            }
        }
        span {
            font-weight: 700;
            font-size: 2rem;
            line-height: 160%;
            border-bottom: 1px solid transparent;
            text-wrap: nowrap;
            white-space: nowrap;
            transition: border-color var(--transition) ease-in;
        }
        svg {
            width: 4rem;
            height: 4rem;
        }
	}
}
</style>
